import React, { useState, useEffect } from 'react';
import moment from 'moment-timezone';

function useTimeZoneClock(date) {
  const [currentTime, setCurrentTime] = useState(
    moment(date).tz('America/Los_Angeles').format('HH:mm:ss')
  );

  useEffect(() => {
      setCurrentTime(
        // moment(date).tz('America/Los_Angeles').format(' hh:mm:ss')
        moment.utc(date, "DD-MM-YYYY HH:mm").tz("America/Los_Angeles").format("YYYY-MM-DD HH:mm")
    );
  }, [date]);

  return currentTime
}

export default useTimeZoneClock;
